import service from "./service";

// GET /billing/plans — every plan and its limits. Public.
const getPlans = async () => {
  return service.get("/billing/plans").then((response) => {
    return response;
  });
};

// GET /billing/subscription — this organization's plan and its limits.
const getSubscription = async () => {
  return service.get("/billing/subscription").then((response) => {
    return response;
  });
};

// GET /billing/invoices - completed charges, most recent first.
const getInvoices = async (params = {}) => {
  return service.get("/billing/invoices", { params }).then((response) => {
    return response;
  });
};

// GET /billing/invoices/:id/pdf - the rendered invoice. It comes back as a
// binary body behind the session token, so it is fetched as a blob rather
// than linked to directly: a plain <a href> carries no Authorization header.
const getInvoicePdf = async (id) => {
  return service
    .get(`/billing/invoices/${id}/pdf`, { responseType: "blob" })
    .then((response) => {
      return response;
    });
};

// GET /billing/checkout/preview - what this change would actually cost,
// prorated against whatever is left of the current plan.
const getCheckoutPreview = async (params) => {
  return service
    .get("/billing/checkout/preview", { params })
    .then((response) => {
      return response;
    });
};

/**
 * POST /billing/checkout - starts a payment. Answers with a checkout token for
 * Helcim's card popup rather than a URL to leave for.
 * @param {{ plan: string, interval: "monthly"|"annual" }} payload
 */
const createCheckout = async (payload) => {
  return service.post("/billing/checkout", payload).then((response) => {
    return response;
  });
};

// POST /billing/cancel - ends the paid subscription and drops to Free right
// away. Answers 400 when the org is already on the free plan.
const cancelSubscription = async () => {
  return service.post("/billing/cancel", {}).then((response) => {
    return response;
  });
};

// POST /billing/retry-payment - pays a renewal that failed. Same plan and
// interval; the billing cycle restarts on the day it goes through.
const retryPayment = async () => {
  return service.post("/billing/retry-payment", {}).then((response) => {
    return response;
  });
};

// POST /billing/checkout/complete - confirms what the card popup reported.
// This is what makes the plan active; no session is needed, because the
// checkout token is the proof. Safe to call twice for the same payment.
const completeCheckout = async (payload) => {
  return service.postPublic("/billing/checkout/complete", payload).then((response) => {
    return response;
  });
};

const billingService = {
  getPlans,
  getSubscription,
  getInvoices,
  getInvoicePdf,
  getCheckoutPreview,
  cancelSubscription,
  createCheckout,
  completeCheckout,
  retryPayment,
};

export default billingService;
